const AppErrorCode = new Map<string, string[]>()

// SDK Core Error
AppErrorCode.set('PLATFORM_UNSUPPORTED', ['C001', 'Platform unsupported'])
AppErrorCode.set('PLATFORM_FEATURE_MISSING_ANDROID', [
  'C002',
  'Platform feature missing Android',
])
AppErrorCode.set('PLATFORM_FEATURE_MISSING_ANDROID_WEB_ECHO_MESSAGE', [
  'C003',
  'Not implemented Android webEchoMessage',
])
AppErrorCode.set('PLATFORM_FEATURE_MISSING_IOS_WEBKIT', [
  'C004',
  'Platform feature missing iOS webkit',
])
AppErrorCode.set('PLATFORM_FEATURE_MISSING_IOS_WEBKIT_MESSAGE_HANDLERS', [
  'C005',
  'Not implemented window webkit messageHandlers',
])
AppErrorCode.set('VALIDATION_ERROR', ['C006', 'validation error'])
AppErrorCode.set('NOT_FOUND_ASSET_ID', ['C006', 'Not found asset id'])
AppErrorCode.set('NOT_FOUND_PAYLOAD', ['C007', 'Not found payload'])
AppErrorCode.set('GET_STORES_ERROR', [
  'C008',
  'Error occurred when getting stores',
])

// Service Error ------------------------------------------------------
AppErrorCode.set('BAD_REQUEST', [
  'S001',
  'The server cannot or will not process the request',
])

// Bridge Error ------------------------------------------------------
AppErrorCode.set('CANNOT_PASRE_MOBILE_RESPONSE', [
  'B001',
  'Cannot parse mobile response',
])

AppErrorCode.set('NOT_FOUND_KEY_DATA', [
  'B002',
  'No data key returned from mobile response',
])

AppErrorCode.set('MOBILE_FORWARDED_ERROR', [
  'B003', // Special error code
  'Mobile forwarded error', // Would be replace by actual message from mobile
])

AppErrorCode.set('DATA_IS_NOT_VALID_JSON_STRING', [
  'B005',
  'Data is not valid JSON string',
])

AppErrorCode.set('TIMEOUT', [
  'B006',
  'Mobile does not call the callback function in time',
])
AppErrorCode.set('INVALID_SCOPE', [
  'B007',
  'Invalid scope',
])
// ARScene Error ------------------------------------------------------
AppErrorCode.set('INVALID_ANCHOR', ['AR001', 'Anchor is invalid'])
AppErrorCode.set('NOT_FOUND_MODEL_ID', ['AR002', 'Model ID not found'])
AppErrorCode.set('AR_SCENE_NOT_FOUND', ['AR003', 'ARScene not found'])
AppErrorCode.set('AR_SCENE_ALREADY_STARTED', [
  'AR004',
  'ARScene already started',
])
AppErrorCode.set('AR_SCENE_HAS_NOT_STARTED_YET', [
  'AR005',
  'ARScene has not started yet',
])
AppErrorCode.set('DUPLICATE_FOOTER', ['AR006', 'Duplicate footer'])

// Main classes ---------------------------------------------------------
class BaseError extends Error {
  protected errorCode: string
  protected cause: string
  constructor(message: string, params: any) {
    super(message)
    this.errorCode = params.errorCode
    this.cause = params.cause || ''
    this.name = params.name || 'Error'

    console.error(this.toString())
  }

  public toString() {
    return `[${this.errorCode}:${this.name}] – ${this.message} ${this.cause}`
  }
}

export class MiniAppCoreError extends BaseError {
  constructor(errorKey: string, params: any = {}) {
    const errors = AppErrorCode.get(errorKey) as string[]
    const [errorCode, errorMessage] = errors
    const _params = { errorCode, name: 'MiniAppCoreError', ...params }
    super(errorMessage, _params)
  }
}

export class BridgeError extends BaseError {
  constructor(errorKey: string, params: any = {}) {
    const errors = AppErrorCode.get(errorKey) as string[]
    let [errorCode, errorMessage] = errors

    // Forwarded mobile error code and message
    if (errorCode === 'B003') {
      // native bridge
      errorCode = `${errorCode}-${params.errorCode}` // B003-0
      errorMessage = params.errorMessage || errorMessage
    }

    const _params = { ...params, errorCode, name: 'BridgeError' }

    super(errorMessage, _params)
  }
}

export class MiniAppARSceneError extends BaseError {
  constructor(errorKey: string, params: any = {}) {
    const errors = AppErrorCode.get(errorKey) as string[]
    const [errorCode, errorMessage] = errors
    const _params = { errorCode, name: 'MiniAppARSceneError', ...params }
    super(errorMessage, _params)
  }
}

export class MiniAppServiceError extends BaseError {
  constructor(errorKey: string, params: any = {}) {
    const errors = AppErrorCode.get(errorKey) as string[]
    const [errorCode, errorMessage] = errors
    const _params = { errorCode, name: 'MiniAppServiceError', ...params }
    super(errorMessage, _params)
  }
}
